import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import { getImpactReportAnalytics } from '../../../../redux/features/crmSlice';
import { impactReportAnalyticsHeader } from './utils/impactReportAnalyticsHeader';

/**
 * impact report analytics.
 * lists the students under the logged in cro , paginated server side.
 * scope is derived from the token by the api ( own id + everyone reporting under it ) ,
 * so nothing about the cro is passed from here.
 * @author Akhil E M
 * @createdAt 11-08-2026
 * @updates 11-08-2026(Akhil EM),
 * @type component
 * @packages react-redux
 */
export default function ImpactReportAnalytics() {
  const dispatch = useDispatch();

  const { data, meta, loading } = useSelector((state) => state.crm.impactReportAnalytics);

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    hiddenColumns: [],
    checkedRowIds: [],
  });

  const dispatchParams = useMemo(
    () => ({
      page: tableState.page,
      limit: tableState.pageSize,
      search: tableState.search,
    }),
    [tableState.page, tableState.pageSize, tableState.search],
  );

  useEffect(() => {
    const thunk = dispatch(getImpactReportAnalytics(dispatchParams));
    //DROPS THE IN FLIGHT REQUEST WHEN THE FILTERS MOVE AGAIN BEFORE IT LANDS
    return () => thunk?.abort();
  }, [dispatch, dispatchParams]);

  const handleRefresh = () => dispatch(getImpactReportAnalytics(dispatchParams));

  return (
    <GlobalWrapper title="Impact Report Analytics">
      <GlobalTable
        headers={impactReportAnalyticsHeader}
        //ONE ROW PER STUDENT , SO THE ADMISSION NUMBER IS THE STABLE KEY
        rowUniqueId="admn_no"
        rows={Array.isArray(data) ? data : []}
        meta={meta}
        tableState={tableState}
        setTableState={setTableState}
        loading={loading}
        showToolTip="student_name"
        checkboxNeeded={false}
        handleRefresh={handleRefresh}
      />
    </GlobalWrapper>
  );
}
